// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__nIaix","Logo_heading":"Logo_Logo_heading__9QdXl","Logo_asset":"Logo_Logo_asset__B0lgu"};